"use client";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
// import Title from "@/components/Title";
// import Subtitle from "@/components/Subtitle";
import InputField from "@/components/InputField";
import Button from "@/components/Button";
import CustomLink from "@/components/CustomLink";
import { clearFieldError } from "@/lib/redux/slices/formSlice";
import SvgIcon from "@/lib/icons/SvgIcon";
import FormHeader from "@/app/(public)/FormHeader";

const ForgotPasswordForm = ({ 
  title, 
  subtitle, 
  onSubmit, 
  fieldErrors,
  formSubmitted,
  setFormSubmitted 
}) => {
  // Validation schema for the email input
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      )
      .required("Email is required"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      email: "",
    }
  });

  // Reset form when submission is successful
  useEffect(() => {
    if (formSubmitted) {
      // Clear form fields
      setValue("email", "");
      clearErrors();
      
      // Reset the submission state
      if (setFormSubmitted) {
        setFormSubmitted(false);
      }
    }
  }, [formSubmitted, setValue, clearErrors, setFormSubmitted]);

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  
  return (
    <div className="grid grid-cols-1 gap-10">
      <FormHeader
        title={title.text}
        subtitle={subtitle.text}
      />
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="grid grid-cols-1 gap-8 mb-8">
          <div className="grid grid-cols-1 gap-2.5">
            <InputField
              float={"false"}
              control={control}
              label="Email"
              placeholder="Enter your email"
              name="email"
              register={register}
              errors={errors}
              setValue={setValue}
              clearErrors={clearFieldError}
            />
            {!errors?.email &&
              fieldErrors &&
              Object.keys(fieldErrors).map((key) => (
                <div key={key} className="text-red-500 text-sm">
                  {fieldErrors[key]}
                </div>
              ))}
          </div>
        </div>
        <Button
          label="Send Email"
          variant="solid"
          size="medium"
          type="submit"
          isLoading={isSubmitting}
          fullWidth={true}
        />
        <div className="mt-8 text-center flex justify-center items-center gap-1">
          <CustomLink
            href="/login"
            label={
              <>
                <SvgIcon name="arrow-left" size="1.5em" />
                <span className="underline ml-1">Back to Login</span>
              </>
            }
            variant="primary"
            className="!text-black font-poppins font-normal hover:!text-[rgba(var(--primary-rgb)/100)] inline-flex"
            target="_self"
          />
        </div>
      </form>
    </div>
  );
};

ForgotPasswordForm.propTypes = {
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    style: PropTypes.object,
    className: PropTypes.string,
  }).isRequired,
  subtitle: PropTypes.shape({
    text: PropTypes.string.isRequired,
    style: PropTypes.object,
    className: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object.isRequired,
  formSubmitted: PropTypes.bool,
  setFormSubmitted: PropTypes.func,
};

export default ForgotPasswordForm;
